'use client';
import { useEffect, useRef, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: any[]) => void;
  }
}

interface Props {
  ymId: number;
}

function YandexMetrikaInner({ ymId }: Props) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
    if (typeof window !== 'undefined' && window.ym) {
      window.ym(ymId, 'hit', url, {
        referrer: document.referrer,
        title: document.title,
      });
    }
  }, [pathname, searchParams, ymId]);

  return null;
}

export default function YandexMetrika({ ymId }: Props) {
  return (
    <Suspense fallback={null}>
      <YandexMetrikaInner ymId={ymId} />
    </Suspense>
  );
}
